@if (isCondensedMode) {
    <div
        [id]="id"
        [class]="fullEntity?.entityType === entityTypes?.OUTLET? 'agpr-entityBusinessCard agpr-entityBusinessCard-isOutlet' :'agpr-entityBusinessCard'"
        [class.agpr-entityBusinessCard--rhp]="isRHP"
        [ngClass]="businessCardClass"
        [class.agpr-entityBusinessCard--condensedMode]="isCondensedMode"
    >
        <div class="agpr-entityBusinessCard-thumbnail" [ngClass]="{'agpr-entityBusinessCard-thumbnail-condensedMode' : isCondensedMode}">
            <agpr-button
                [ngClass]="{
                    'agpr-entityBusinessCard-thumbnail-img--nonClickable': !canOpenFullProfile,
                    'agpr-entityBusinessCard-thumbnail-img--condensedMode': isCondensedMode,
                }"
                [imageClass]="{
                    'agpr-entityBusinessCard-thumbnail-img': true,
                    'agpr-entityBusinessCard-thumbnail-img--scrolled': isScrolled,
                    'agpr-entityBusinessCard-thumbnail-img--condensedMode': isCondensedMode
                }"
                [style]="buttonTypes.image"
                [imageUrl]="fullEntity?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                [imageUrlDefault]="imageDefault[fullEntity?.entityType]"
                [tooltip]="canOpenFullProfile ? 'Discover.entityProfile.expand': ''"
                ariaLabel="Discover.entityProfile.expand"
                (click)="openFullProfile(fullEntity)"
                [hideImageAlt]="true"
            ></agpr-button>
        </div>
        <div class="agpr-entityBusinessCard-basicInfo-container">
            <div
                *ngIf="fullEntity?.entityType === entityTypes.OUTLET"
                class="agpr-entityBusinessCard-basicInfo"
                [ngClass]="basicInfoClass"
                [class.agpr-entityBusinessCard-basicInfo--condensedMode]="isCondensedMode"
            >
                <div
                    class="agpr-entityBusinessCard-name"
                    [ngClass]="{
                        'agpr-entityBusinessCard-name--scrolled': isScrolled,
                        'agpr-entityBusinessCard-name--nonClickable': !canOpenFullProfile,
                        'agpr-entityBusinessCard-name--condensedMode': isCondensedMode,
                    }"
                    (click)="isRHP && openFullProfile(fullEntity)"
                    role="heading"
                    [attr.aria-level]="isRHP ? 4 : 1"
                >
                    <span
                        #outletNameLabel
                        tabindex="0"
                    >
                        {{ outletEntity.name }}
                    </span>
                </div>
            </div>
            <div
                *ngIf="fullEntity?.entityType === entityTypes.CONTACT"
                class="agpr-entityBusinessCard-basicInfo"
                [ngClass]="basicInfoClass"
                [class.agpr-entityBusinessCard-basicInfo--condensedMode]="isCondensedMode"
            >
                <div
                    class="agpr-entityBusinessCard-name"
                    [ngClass]="{
                        'agpr-entityBusinessCard-name--scrolled': isScrolled,
                        'agpr-entityBusinessCard-name--nonClickable': !canOpenFullProfile,
                        'agpr-entityBusinessCard-name--condensedMode': isCondensedMode,
                    }"
                    (click)="isRHP && openFullProfile(fullEntity)"
                    role="heading"
                    [attr.aria-level]="isRHP ? 4 : 1"
                >
                    <span
                        #contactNameLabel
                    >
                        {{ contactEntity.firstName }} {{ contactEntity.lastName }}
                    </span>
                </div>
            </div>
            <div
                *ngIf="isScrolled"
                class="agpr-entityBusinessCard-spacer"
            ></div>
            @if (showOutletInfo) {
                <div
                    class="agpr-entityBusinessCard-outlet"
                    [ngClass]="{
                        'agpr-entityBusinessCard-outlet--scrolled': isScrolled,
                        'agpr-entityBusinessCard-outlet--condensedMode': isCondensedMode,
                    }"
                >
                    <div
                        *ngIf="selectedEmployment?.outlet && contactEntity?.employmentModels?.length === 1"
                        class="agpr-entityBusinessCard-outletName"
                        [ngClass]="outletNameClass"
                        [class.agpr-entityBusinessCard-outletName--condensedMode]="isCondensedMode"
                    >
                        <agpr-button
                            *ngIf="selectedEmployment?.outlet"
                            [style]="buttonTypes.link"
                            class="agpr-entityBusinessCard-outletName-link"
                            [ngClass]="{'agpr-entityBusinessCard-outletName-link--isRHP': isRHP}"
                            (click)="targetingRhpContextsService.selectOutletContactTab(outletContactTabType.outletProfile)"
                        >
                            <div
                                #outletName
                                (mouseenter)="checkTruncatedText(outletName)"
                                [pTooltip]="isTruncated ? selectedEmployment?.outlet.name: null"
                                tooltipPosition="top"
                                class="agpr-entityBusinessCard-outletName-link-text"
                                [ngClass]="{'agpr-entityBusinessCard-outletName-link-text--condensedMode': isCondensedMode}"
                            >
                                {{ selectedEmployment?.outlet.name }}
                            </div>
                        </agpr-button>
                    </div>
                    <agpr-dropdown
                        *ngIf="contactEntity?.employmentModels?.length > 1"
                        [ngClass]="outletDropdownClass"
                        [class.agpr-entityBusinessCard-outletDropdown-condensedMode]="isCondensedMode"
                        [id]="id + '_employmentDropdown'"
                        class="agpr-entityBusinessCard-outletDropdown"
                        panelStyleClass="agpr-entityBusinessCard-outletDropdown-panel"
                        [style]="dropdownTypesEnum.borderless"
                        [options]="outletDropdownOptions"
                        [ngModel]="selectedEmploymentDropdown"
                        (ngModelChange)="employmentSelectedFromDropdown($event.value)"
                        ariaLabel="Discover.targeting.actions.selectEmployedtOutlet"
                        [showTooltip]="true"
                    >
                    </agpr-dropdown>
                </div>
            }
        </div>
    </div>
}@else {
    <div
        [id]="id"
        [class]="fullEntity?.entityType === entityTypes?.OUTLET? 'agpr-entityBusinessCard agpr-entityBusinessCard-isOutlet' :'agpr-entityBusinessCard'"
        [class.agpr-entityBusinessCard--rhp]="isRHP"
        [ngClass]="businessCardClass"
    >
        <div class="agpr-entityBusinessCard-thumbnail">
            @if (canOpenFullProfile) {
                <agpr-button
                    class="agpr-profileToggle"
                    icon="fa-solid fa-duotone fa-circle-chevron-left"
                    [style]="buttonTypes.icon"
                    [ariaLabel]="'Discover.entityProfile.expand' | localize"
                    [tooltip]="'Discover.entityProfile.expand'"
                    (click)="openFullProfile(fullEntity)"
                ></agpr-button>
            }
            <agpr-button
                [ngClass]="{
                    'agpr-entityBusinessCard-thumbnail-img--nonClickable': !canOpenFullProfile
                }"
                [imageClass]="{
                    'agpr-entityBusinessCard-thumbnail-img': true,
                    'agpr-entityBusinessCard-thumbnail-img--scrolled': isScrolled
                }"
                [style]="buttonTypes.image"
                [imageUrl]="fullEntity?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                [imageUrlDefault]="imageDefault[fullEntity?.entityType]"
                [tooltip]="canOpenFullProfile ? 'Discover.entityProfile.expand': ''"
                ariaLabel="Discover.entityProfile.expand"
                (click)="openFullProfile(fullEntity)"
                [hideImageAlt]="true"
            ></agpr-button>
            @if (!isScrolled && fullEntity?.entityType !== entityTypes?.OUTLET && selectedEmployment?.outlet) {
                <ng-container>
                    <img
                        class="agpr-entityBusinessCard-thumbnail-img agpr-entityBusinessCard-thumbnail-img--outlet"
                        [ngClass]="{'agpr-entityBusinessCard-thumbnail-img--outlet--nonClickable': !canOpenFullProfile}"
                        [agprImageSrc]="selectedEmployment?.outlet.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                        [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                        alt=""
                    />
                </ng-container>
            }
        </div>
        <div
            *ngIf="fullEntity?.entityType === entityTypes.OUTLET"
            class="agpr-entityBusinessCard-basicInfo"
            [ngClass]="basicInfoClass"
        >
            <div
                class="agpr-entityBusinessCard-name"
                [ngClass]="{
                    'agpr-entityBusinessCard-name--scrolled': isScrolled,
                    'agpr-entityBusinessCard-name--nonClickable': !canOpenFullProfile
                }"
                (click)="isRHP && openFullProfile(fullEntity)"
                role="heading"
                [attr.aria-level]="isRHP ? 4 : 1"
            >
                <span
                    #outletNameLabel
                >
                    {{ outletEntity.name }}
                </span>
            </div>
            @if (outletEntity?.mediaTypes?.length > 0) {
                <div
                    class="agpr-entityBusinessCard-outlet-jobTitle"
                    [ngClass]="outletTitleClass"
                >
                    <div
                    class="agpr-entityBusinessCard-jobTitle-mediaTypes"
                        *ngFor="let mediaType of outletEntity.mediaTypes; let last = last"
                    >
                        {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                    </div>

                    <div
                        class="agpr-entityBusinessCard-jobTitle-mediaTypes"
                        *ngIf = "outletEntity.coverageFocus"

                    >
                        {{ ' - ' }}{{ outletEntity.coverageFocus.displayString | localize }}
                    </div>
                </div>
            }
            <div
                class="agpr-entityBusinessCard-badges"
                [ngClass]="badgesClass"
            >
            @for (badge of outletEntity.badges; track badge.tooltip) {
                <span
                    role="img"
                    class="agpr-entityBusinessCard-badge"
                    [ngClass]="badge?.iconClass"
                    [agprTooltip]="badge?.tooltip"
                ></span>
            }
            </div>
        </div>
        <div
            *ngIf="fullEntity?.entityType === entityTypes.CONTACT"
            class="agpr-entityBusinessCard-basicInfo"
            [ngClass]="basicInfoClass"
        >
            <div
                class="agpr-entityBusinessCard-name"
                [ngClass]="{
                    'agpr-entityBusinessCard-name--scrolled': isScrolled,
                    'agpr-entityBusinessCard-name--nonClickable': !canOpenFullProfile
                }"
                (click)="isRHP && openFullProfile(fullEntity)"
                role="heading"
                [attr.aria-level]="isRHP ? 4 : 1"
            >
                <span
                    #contactNameLabel
                    tabindex="0"
                >
                    {{ contactEntity.firstName }} {{ contactEntity.lastName }}
                </span>
                <div
                    *ngIf="!isRHP && contactEntity?.badges"
                    class="agpr-entityBusinessCard-badges"
                    [ngClass]="badgesClass"
                >
                    <span
                        *ngFor="let badge of contactEntity.badges"
                        role="img"
                        class="agpr-entityBusinessCard-badge"
                        [ngClass]="badge?.iconClass"
                        [agprTooltip]="badge?.tooltip"
                    ></span>
                </div>
            </div>
            @if (selectedEmployment) {
                <div
                    #jobTitle
                    class="agpr-entityBusinessCard-jobTitle"
                    [ngClass]="profileTitleClass"
                    (mouseenter)="checkTruncatedText(jobTitle)"
                    [pTooltip]="isTruncated ? selectedEmployment?.jobTitle: null"
                >
                    {{ selectedEmployment.jobTitle }}
                </div>
            }
        </div>
        <div
            *ngIf="isScrolled"
            class="agpr-entityBusinessCard-spacer"
        ></div>
        <div
            class="agpr-entityBusinessCard-outlet"
            [ngClass]="{ 'agpr-entityBusinessCard-outlet--scrolled': isScrolled}"
        >
            <div
                *ngIf="selectedEmployment?.outlet && contactEntity?.employmentModels?.length === 1"
                class="agpr-entityBusinessCard-outletName"
                [ngClass]="outletNameClass"
            >
                <agpr-button
                    *ngIf="selectedEmployment?.outlet"
                    [style]="buttonTypes.link"
                    class="agpr-entityBusinessCard-outletName-link"
                    [ngClass]="{'agpr-entityBusinessCard-outletName-link--isRHP': isRHP}"
                    (click)="targetingRhpContextsService.selectOutletContactTab(outletContactTabType.outletProfile)"
                >
                    <div
                        #outletName
                        (mouseenter)="checkTruncatedText(outletName)"
                        [pTooltip]="isTruncated ? selectedEmployment?.outlet.name: null"
                        tooltipPosition="top"
                        class="agpr-entityBusinessCard-outletName-link-text"
                    >
                        {{ selectedEmployment?.outlet.name }}
                    </div>
                </agpr-button>
            </div>
            <agpr-dropdown
                *ngIf="contactEntity?.employmentModels?.length > 1"
                [ngClass]="outletDropdownClass"
                [id]="id + '_employmentDropdown'"
                class="agpr-entityBusinessCard-outletDropdown"
                panelStyleClass="agpr-entityBusinessCard-outletDropdown-panel"
                [style]="dropdownTypesEnum.borderless"
                [options]="outletDropdownOptions"
                [ngModel]="selectedEmploymentDropdown"
                (ngModelChange)="employmentSelectedFromDropdown($event.value)"
                ariaLabel="Discover.targeting.actions.selectEmployedtOutlet"
                [showTooltip]="true"
            >
            </agpr-dropdown>
            <div
                *ngIf="!isRHP"
                class="agpr-entityBusinessCard-actions"
            >
                <agpr-split-button
                    class="agpr-entityBusinessCard-buttonContainer"
                    [id]="id + '_contactBusinessCard_actions'"
                    [label]="'Discover.targeting.actions.actions' | localize"
                    [style]="buttonTypes.tertiary"
                    panelPositionY="bottom"
                    panelPositionX="right"
                    [options]="actions"
                ></agpr-split-button>
            </div>
        </div>
    </div>
}
